var v1="<div class=\"container page-round-detail\"><div id=\"map_canvas\" ng-if=\"rmCtrl.mapOptions\" ui-map=\"::rmCtrl.myMap\" ui-options=\"::rmCtrl.mapOptions\" class=\"col-12 map\"></div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/round-map/round-map.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/round-detail/round-map/round-map.jade
// module id = 576
// module chunks = 0